import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSchemeStoreVisitRestoreApplyListDataApi(data) {
  return request({
    url: 'tms-web/schemeStoreVisitRestoreApply/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSchemeStoreVisitRestoreApplyListDataApi(data) {
  return request({
    url: 'tms-web/schemeStoreVisitRestoreApply/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveSchemeStoreVisitRestoreApplyApi(data) {
  return request({
    url: 'tms-web/schemeStoreVisitRestoreApply/save',
    method: 'post',
    data
  })
}

// 复核
export function checkSchemeStoreVisitRestoreApplyApi(data) {
  return request({
    url: 'tms-web/schemeStoreVisitRestoreApply/check',
    method: 'post',
    data
  })
}

// 作废
export function deleteSchemeStoreVisitRestoreApplyApi(data) {
  return request({
    url: 'tms-web/schemeStoreVisitRestoreApply/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewSchemeStoreVisitRestoreApplyApi(data) {
  return request({
    url: 'tms-web/schemeStoreVisitRestoreApply/view',
    method: 'post',
    data
  })
}

// 统计方案待办数量
export function countTodoSchemeStoreVisitRestoreApplyApi(data) {
  return request({
    url: 'tms-web/schemeStoreVisitRestoreApply/countTodo',
    method: 'post',
    data
  })
}